/**
 * Ultra-Robust Globo Swatch Fallback
 * Resolves swatch images and colors for Globo Filter & Search cards.
 * Implements multi-tier fallback: Hyphen CDN -> Underscore CDN -> Clean Handles -> Globo App Swatch -> PDP Hex Dictionary.
 */
(function () {
    // Shared cache for verified swatch styles
    window.__globoSwatchCache = window.__globoSwatchCache || {};
    var cache = window.__globoSwatchCache;
    var pendingProbes = {};

    var BASE_CDN = 'https://cdn.shopify.com/s/files/1/0696/2731/4250/files/';

    // PDP-identical 50+ color keyword to HEX fallback dictionary
    var COLOR_HEX_MAP = [
        { keywords: ['mauve', 'lilac', 'lavender'], hex: '#E6B8E6' },
        { keywords: ['violet', 'purple', 'plum'], hex: '#9370DB' },
        { keywords: ['black'], hex: '#000000' },
        { keywords: ['off-white', 'off white'], hex: '#FAF9F6' },
        { keywords: ['ivory'], hex: '#FFFFF0' },
        { keywords: ['cream', 'creme'], hex: '#FFFDD0' },
        { keywords: ['eggshell'], hex: '#F0EAD6' },
        { keywords: ['bone'], hex: '#E3DAC9' },
        { keywords: ['linen'], hex: '#FAF0E6' },
        { keywords: ['vanilla'], hex: '#F3E5AB' },
        { keywords: ['white', 'chalk', 'snow'], hex: '#FFFFFF' },
        { keywords: ['red', 'crimson'], hex: '#DC143C' },
        { keywords: ['burgundy', 'wine', 'maroon'], hex: '#800020' },
        { keywords: ['pink', 'rose', 'blush'], hex: '#FF69B4' },
        { keywords: ['coral', 'salmon'], hex: '#FF7F50' },
        { keywords: ['peach', 'apricot'], hex: '#FFDAB9' },
        { keywords: ['orange', 'rust'], hex: '#FF8C00' },
        { keywords: ['yellow', 'gold'], hex: '#FFD700' },
        { keywords: ['mustard'], hex: '#FFDB58' },
        { keywords: ['chocolate'], hex: '#7B3F00' },
        { keywords: ['brown'], hex: '#8B4513' },
        { keywords: ['tan', 'beige', 'khaki'], hex: '#D2B48C' },
        { keywords: ['taupe', 'mocha'], hex: '#967969' },
        { keywords: ['camel', 'sand'], hex: '#C19A6B' },
        { keywords: ['nude'], hex: '#E3BC9A' },
        { keywords: ['olive', 'sage'], hex: '#6B8E23' },
        { keywords: ['green', 'emerald'], hex: '#228B22' },
        { keywords: ['mint', 'lime'], hex: '#00FF7F' },
        { keywords: ['teal', 'turquoise'], hex: '#008080' },
        { keywords: ['aqua', 'cyan'], hex: '#00FFFF' },
        { keywords: ['navy', 'indigo'], hex: '#000080' },
        { keywords: ['cobalt', 'sapphire'], hex: '#0047AB' },
        { keywords: ['denim'], hex: '#1560BD' },
        { keywords: ['blue'], hex: '#1E90FF' },
        { keywords: ['charcoal', 'slate'], hex: '#36454F' },
        { keywords: ['gray', 'grey', 'silver'], hex: '#808080' }
    ];

    // Load session storage cache if available
    try {
        var saved = sessionStorage.getItem('hco_swatch_cache_v2');
        if (saved) {
            var parsed = JSON.parse(saved);
            for (var k in parsed) {
                if (!cache[k]) cache[k] = parsed[k];
            }
        }
    } catch (e) { }

    function persistCache() {
        try {
            sessionStorage.setItem('hco_swatch_cache_v2', JSON.stringify(cache));
        } catch (e) { }
    }

    function getHexFallback(text) {
        if (!text) return null;
        var lower = text.toLowerCase();
        for (var i = 0; i < COLOR_HEX_MAP.length; i++) {
            var entry = COLOR_HEX_MAP[i];
            for (var j = 0; j < entry.keywords.length; j++) {
                if (lower.indexOf(entry.keywords[j]) !== -1) {
                    return entry.hex;
                }
            }
        }
        return null;
    }

    function cleanColorString(val) {
        if (!val) return '';
        var raw = val.toLowerCase().replace(/[_/]/g, ' ').replace(/-/g, ' ');
        var clean = raw.split('ddpattern')[0].split('pattern')[0].replace(/\bdd\b/g, '').replace(/[0-9]/g, '').trim();
        return clean;
    }

    function testImageUrl(url) {
        return new Promise(function (resolve) {
            if (!url) return resolve(false);
            var img = new Image();
            img.onload = function () { resolve(true); };
            img.onerror = function () { resolve(false); };
            img.src = url;
        });
    }

    function applyStyle(el, result) {
        if (!el || !result) return;
        if (result.type === 'image') {
            el.style.backgroundImage = "url('" + result.url + "')";
            el.style.backgroundColor = 'transparent';
        } else if (result.type === 'gradient') {
            el.style.backgroundImage = result.bg;
            el.style.backgroundColor = 'transparent';
        } else if (result.type === 'color') {
            el.style.backgroundImage = 'none';
            el.style.backgroundColor = result.color;
        }
        el.dataset.swatchChecked = '1';
        el.dataset.swatchResolved = result.type;
    }

    function buildCandidateUrls(rawVal, cleanVal, fallbackSwatch) {
        var list = [];
        var seen = {};

        function add(url) {
            if (url && !seen[url]) {
                seen[url] = true;
                list.push(url);
            }
        }

        var r = (rawVal || '').trim();
        var c = (cleanVal || cleanColorString(rawVal)).trim();

        if (r) {
            // 1. Hyphenated (e.g. brown-stripepatternb1573.jpg)
            var hyp = r.toLowerCase().replace(/[\s_]+/g, '-').replace(/[^\w-]/g, '');
            if (hyp) add(BASE_CDN + encodeURIComponent(hyp) + '.jpg');

            // 2. Underscore (e.g. yellow_stripepatternb1554.jpg)
            var und = r.toLowerCase().replace(/[\s-]+/g, '_').replace(/[^\w_]/g, '');
            if (und) add(BASE_CDN + encodeURIComponent(und) + '.jpg');

            // 3. Raw spaces replaced with hyphen / underscore directly
            add(BASE_CDN + encodeURIComponent(r.replace(/\s+/g, '-')) + '.jpg');
            add(BASE_CDN + encodeURIComponent(r.replace(/\s+/g, '_')) + '.jpg');
        }

        if (c) {
            // 4. Clean hyphen (e.g. brown-stripe.jpg)
            var c_hyp = c.toLowerCase().replace(/[\s_]+/g, '-').replace(/[^\w-]/g, '');
            if (c_hyp) add(BASE_CDN + encodeURIComponent(c_hyp) + '.jpg');

            // 5. Clean underscore (e.g. brown_stripe.jpg)
            var c_und = c.toLowerCase().replace(/[\s-]+/g, '_').replace(/[^\w_]/g, '');
            if (c_und) add(BASE_CDN + encodeURIComponent(c_und) + '.jpg');

            // 6. Base color (e.g. brown.jpg)
            var firstWord = c.split(' ')[0];
            if (firstWord && firstWord !== c_hyp) {
                add(BASE_CDN + encodeURIComponent(firstWord) + '.jpg');
            }
        }

        // 7. Globo manual swatch image if provided
        if (fallbackSwatch) {
            add(fallbackSwatch);
        }

        return list;
    }

    function resolveSwatch(rawVal, cleanVal, fallbackSwatch, color1, color2) {
        var key = (rawVal || '').trim().toLowerCase();
        if (!key && cleanVal) key = cleanVal.trim().toLowerCase();
        if (!key) return Promise.resolve(null);

        // Check memory / session cache
        if (cache[key]) {
            return Promise.resolve(cache[key]);
        }

        // Deduplicate ongoing network probes for the exact same color key
        if (pendingProbes[key]) {
            return pendingProbes[key];
        }

        var promise = (async function () {
            var candidateUrls = buildCandidateUrls(rawVal, cleanVal, fallbackSwatch);

            // Test candidate URLs in priority order
            for (var i = 0; i < candidateUrls.length; i++) {
                var url = candidateUrls[i];
                var ok = await testImageUrl(url);
                if (ok) {
                    var resImg = { type: 'image', url: url };
                    cache[key] = resImg;
                    persistCache();
                    delete pendingProbes[key];
                    return resImg;
                }
            }

            // If images failed, check Globo app colors
            if (color1 && color2) {
                var resGrad = { type: 'gradient', bg: 'linear-gradient(135deg, ' + color1 + ' 50%, ' + color2 + ' 50%)' };
                cache[key] = resGrad;
                persistCache();
                delete pendingProbes[key];
                return resGrad;
            } else if (color1) {
                var resCol1 = { type: 'color', color: color1 };
                cache[key] = resCol1;
                persistCache();
                delete pendingProbes[key];
                return resCol1;
            }

            // Keyword to HEX fallback matching PDP palette
            var hex = getHexFallback(cleanVal) || getHexFallback(rawVal) || '#E0E0E0';
            var resHex = { type: 'color', color: hex };
            cache[key] = resHex;
            persistCache();
            delete pendingProbes[key];
            return resHex;
        })();

        pendingProbes[key] = promise;
        return promise;
    }

    function checkSwatchImages(root) {
        var swatches = (root || document).querySelectorAll('.spf-product__swatch-image, .spf-card-swatch');
        if (!swatches.length) return;

        swatches.forEach(function (el) {
            if (el.dataset.swatchChecked && el.dataset.swatchResolved) {
                return;
            }

            var rawVal = el.getAttribute('data-swatch-raw') ||
                el.getAttribute('data-option-value') ||
                el.closest('.spf-product__swatch')?.getAttribute('data-option-value') ||
                '';

            var cleanVal = el.getAttribute('data-swatch-clean') ||
                el.getAttribute('data-swatch-label') ||
                '';

            var fallbackSwatch = el.getAttribute('data-fallback-swatch') || '';
            var color1 = el.getAttribute('data-swatch-color1') || '';
            var color2 = el.getAttribute('data-swatch-color2') || '';

            var key = (rawVal || cleanVal).trim().toLowerCase();

            // Synchronous fast-path: if already cached, apply instantly with zero network delay
            if (cache[key]) {
                applyStyle(el, cache[key]);
                return;
            }

            // Asynchronous fallback resolution
            resolveSwatch(rawVal, cleanVal, fallbackSwatch, color1, color2).then(function (result) {
                if (result) {
                    applyStyle(el, result);
                }
            });
        });
    }

    // Initial load checks
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () { checkSwatchImages(); });
    } else {
        checkSwatchImages();
    }

    // Globo filter render hook (runs immediately, at 50ms, and at 250ms)
    window.addEventListener('globoFilterRenderCompleted', function () {
        checkSwatchImages();
        setTimeout(checkSwatchImages, 50);
        setTimeout(checkSwatchImages, 250);
    });

    // Debounced MutationObserver for dynamic DOM injections
    var rafPending = false;
    var observer = new MutationObserver(function (mutations) {
        var hasNew = mutations.some(function (m) {
            return m.addedNodes && m.addedNodes.length > 0;
        });
        if (hasNew && !rafPending) {
            rafPending = true;
            window.requestAnimationFrame(function () {
                rafPending = false;
                checkSwatchImages();
            });
        }
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });

    // Expose utility for diagnostics or external calls
    window.__hcoCheckSwatches = checkSwatchImages;
})();
